<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">বাল্ক কর সংগ্রহ</h1>
        <p class="page-subtitle">এক্সেল ফাইল ব্যবহার করে একসাথে একাধিক কর সংগ্রহ করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" routerLink="/admin/tax-collection" class="btn-secondary-modern">
          <i class="fas fa-money-bill-wave"></i>
          একক কর সংগ্রহ
        </button>
        <button type="button" routerLink="/admin/tax-collection-list" class="btn-outline-modern">
          <i class="fas fa-list"></i>
          কর সংগ্রহ তালিকা
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="content-grid">
    
    <!-- Configuration Section -->
    <div class="content-card slide-up">
      <div class="card-header">
        <h3 class="card-title bangla-title">
          <i class="fas fa-cog"></i>
          কনফিগারেশন
        </h3>
      </div>
      
      <div class="card-body">
        <div class="configuration-section">
          <div class="config-group">
            <div class="form-group">
              <label for="financialYear" class="form-label bangla-label">অর্থবছর:</label>
              <select id="financialYear" [(ngModel)]="financialYear" class="form-control-modern">
                <option *ngFor="let year of yearList" [value]="year">
                  {{ formatFinancialYear(year) }}
                </option>
              </select>
            </div>
          </div>
          
          <div class="config-group">
            <div class="checkbox-group">
              <div class="form-check-modern">
                <input 
                  type="checkbox" 
                  class="form-check-input-modern" 
                  id="autoCalculate" 
                  [(ngModel)]="autoCalculate"
                >
                <label class="form-check-label-modern bangla-label" for="autoCalculate">
                  <i class="fas fa-calculator"></i>
                  অটো ক্যালকুলেট (খানার ধরন অনুযায়ী ট্যাক্স গণনা)
                </label>
              </div>
              
              <div class="form-check-modern">
                <input 
                  type="checkbox" 
                  class="form-check-input-modern" 
                  id="allowDuplicates" 
                  [(ngModel)]="allowDuplicates"
                >
                <label class="form-check-label-modern bangla-label" for="allowDuplicates">
                  <i class="fas fa-copy"></i>
                  ডুপ্লিকেট অনুমতি (একই বছরে পুনরায় ট্যাক্স সংগ্রহ)
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- File Upload Section -->
    <div class="content-card slide-up">
      <div class="card-header">
        <h3 class="card-title bangla-title">
          <i class="fas fa-upload"></i>
          এক্সেল ফাইল আপলোড
        </h3>
      </div>
      
      <div class="card-body">
        <div class="upload-section">
          <div class="upload-form">
            <div class="form-group">
              <label class="form-label bangla-label">এক্সেল ফাইল নির্বাচন করুন</label>
              <input 
                (change)="ReadExcel($event)" 
                type="file" 
                name="holdingNo" 
                class="form-control" 
                id="excelFile" 
                accept=".xlsx,.xls"
                placeholder="এক্সেল ফাইল নির্বাচন করুন">
            </div>
            
            <div class="button-group">
              <button 
                (click)="uploadToDatabase()" 
                type="button" 
                class="btn-primary-modern"
                [disabled]="!ExcelData || ExcelData.length === 0">
                <i class="fas fa-database"></i>
                ডাটাবেসে আপলোড
              </button>
              
              <button 
                (click)="exportSampleToExcel()" 
                type="button" 
                class="btn-outline-modern">
                <i class="fas fa-download"></i>
                নমুনা ফাইল ডাউনলোড
              </button>
            </div>
          </div>
          
          <!-- Upload Instructions -->
          <div class="upload-instructions">
            <h4 class="bangla-label">
              <i class="fas fa-info-circle"></i>
              নির্দেশাবলী
            </h4>
            <ul class="instruction-list">
              <li>প্রথমে "নমুনা ফাইল ডাউনলোড" বাটন ক্লিক করে নমুনা এক্সেল ফাইল ডাউনলোড করুন</li>
              <li>নমুনা ফাইলের ফরম্যাট অনুযায়ী তথ্য পূরণ করুন</li>
              <li>সম্পূর্ণ তথ্য পূরণের পর ফাইলটি আপলোড করুন</li>
              <li>ডেটা যাচাই করার পর "ডাটাবেসে আপলোড" বাটন ক্লিক করুন</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Preview Section -->
    <div class="content-card slide-up" *ngIf="ExcelData && ExcelData.length > 0">
      <div class="card-header">
        <h3 class="card-title bangla-title">
          <i class="fas fa-table"></i>
          ডেটা প্রিভিউ
        </h3>
        <div class="card-actions">
          <span class="data-count">
            মোট <strong>{{ExcelData.length}}</strong> টি রেকর্ড
          </span>
        </div>
      </div>
      
      <div class="card-body">
        <div class="table-responsive">
          <table id="tableId" class="table-modern">
            <thead>
              <tr>
                <th class="bangla-label">সিরিয়াল</th>
                <th class="bangla-label">QR কোড</th>
                <th class="bangla-label">হোল্ডিং নং</th>
                <th class="bangla-label">পরিমাণ</th>
                <th class="bangla-label">অটো ক্যালকুলেট</th>
                <th class="bangla-label">ডুপ্লিকেট অনুমতি</th>
                <th class="bangla-label">টিপ্পনী</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of ExcelData; let i = index" [class.table-striped]="i % 2 === 0">
                <td class="bangla-text">{{ i + 1 }}</td>
                <td class="bangla-text">{{ data['QR Code'] || data['qr_code'] || data['QRCode'] || '-' }}</td>
                <td class="bangla-text">{{ data['Holding Number'] || data['holding_number'] || data['HoldingNumber'] || '-' }}</td>
                <td class="bangla-text amount-cell">{{ data['Amount'] || data['amount'] || '-' }}</td>
                <td class="bangla-text">
                  <span class="status-badge-modern" 
                        [class]="parseBoolean(data['Auto Calculate'] || data['auto_calculate'] || data['AutoCalculate'] || autoCalculate) ? 'badge-success' : 'badge-secondary'">
                    {{ parseBoolean(data['Auto Calculate'] || data['auto_calculate'] || data['AutoCalculate'] || autoCalculate) ? 'হ্যাঁ' : 'না' }}
                  </span>
                </td>
                <td class="bangla-text">
                  <span class="status-badge-modern" 
                        [class]="parseBoolean(data['Allow Duplicate'] || data['allow_duplicate'] || data['AllowDuplicate'] || allowDuplicates) ? 'badge-warning' : 'badge-success'">
                    {{ parseBoolean(data['Allow Duplicate'] || data['allow_duplicate'] || data['AllowDuplicate'] || allowDuplicates) ? 'হ্যাঁ' : 'না' }}
                  </span>
                </td>
                <td class="bangla-text">{{ data['Notes'] || data['notes'] || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="content-card slide-up" *ngIf="!ExcelData || ExcelData.length === 0">
      <div class="card-body">
        <div class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-file-excel"></i>
          </div>
          <h3 class="bangla-title">কোন ডেটা পাওয়া যায়নি</h3>
          <p class="bangla-text">এক্সেল ফাইল আপলোড করুন অথবা নমুনা ফাইল ডাউনলোড করে শুরু করুন</p>
          <button type="button" (click)="exportSampleToExcel()" class="btn-primary-modern">
            <i class="fas fa-download"></i>
            নমুনা ফাইল ডাউনলোড
          </button>
        </div>
      </div>
    </div>

  </div>
</div> 